import React from 'react'
import Link from 'gatsby-link'
import styles from './digest.module.scss'

const Digest = ({node: {path, context: {index, date, title, external}}}) => {
  const link = external ? (<a target="_blank" href={external}>{title}</a>):(<Link to={path}>{title}</Link>);

  return (<div key={index}>
    <div>Digest #{index}</div>
    <h5 className={styles.link}>
      {link}
    </h5>
    <time>{date}</time>
    <hr />
  </div>)
};

const DigestPage = ({
  data: {
    allSitePage: { edges },
  },
}) => (<div className={styles.digest}>
  <h2>Previous Digests</h2>
  <p>Browse back issues of ML Review newsletter.</p>
  <hr />
  {edges.map(Digest)}
</div>);

export default DigestPage

export const pageQuery = graphql`
  query DigestQuery {
    allSitePage(
      filter: {context: {type: {eq: "digest"}}},
      sort: { order: DESC, fields: [context___date] }
    ) {
      ...DigestPageFragment
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/digest.js